import axiosRequest from "@/api/axios-optimize"

// 获取列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/out`, { params: data, ...config})
}

// 新增
export function createItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/out`, data, config)
}

// 获取详情
export function getDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/out/${data.id}`, { params: {}, ...config})
}

// 更新
export function updateItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.put(`/xiaobuAdmin/inventory/out/${data.outId}`, data, config)
}

// 作废出库单
export function discardOut(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/out/discardOut`, data, config)
}

// 删除
export function deleteItem(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/inventory/out/${data.id}`, { ...config}) // 省略data入参 或 params入参
}

// 确认出库
export function confirmOut(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/inventory/out/confirmOut`, data, config)
}

// 获取出库列表
export function getOutDetail(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/out/getOutDetail`, { params: data, ...config})
}

// 批量删除出库单
export function batchDeleteItems(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/inventory/out/batchDelete`, { data, ...config})
}
